import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, IconSvgButton, Flex, Button, Divider, Text } from "samba-ui";
import styled from "styled-components";

const Checkbox = styled.input`
  width: 10px;
  height: 10px;
`;

const StyledFlex = styled(Flex)`
  opacity: ${p => (p.disabled ? 0.5 : 1)};
  pointer-events: ${p => (p.disabled ? "none" : "auto")};
`;

const getFilter = name => {
  return {
    filters: { [name]: [] },
    isCustom: false,
    isDefault: true,
    name,
    visible: [name]
  };
};
const TV_Viewership_Behavior = dashboardType => {
  let name = "TV_Viewership_Behavior";

  if (dashboardType === "svtr") {
    name = "SVTR_TV_Viewership_Behavior";
  } else if (dashboardType === "vtr") {
    name = "VTR_TV_Viewership_Behavior";
  } else if (dashboardType.indexOf("bcr") > -1) {
    name = "BCR_TV_Viewership_Behavior";
  }

  return { [name]: getFilter(name) };
};

const Demographics = dashboardType => {
  let name = "Demographics";

  if (dashboardType === "svtr") {
    name = "SVTR_Demographics";
  } else if (dashboardType === "vtr") {
    name = "VTR_Demographics";
  } else if (dashboardType.indexOf("bcr") > -1) {
    name = "BCR_Demographics";
  }

  return { [name]: getFilter(name) };
};

const Campaign_Date = dashboardType => {
  let name = "Campaign_Date";

  if (dashboardType === "svtr") {
    name = "SVTR_Campaign_Date";
  } else if (dashboardType === "vtr") {
    name = "VTR_Campaign_Date";
  } else if (dashboardType.indexOf("bcr") > -1) {
    name = "BCR_Conversion_End_Date";
  }

  return { [name]: getFilter(name) };
};

const DMA_Code = dashboardType => {
  let name = "DMA_Code";

  if (dashboardType === "svtr") {
    name = "SVTR_DMA_Code";
  } else if (dashboardType === "vtr") {
    name = "VTR_DMA_Code";
  } else if (dashboardType.indexOf("bcr") > -1) {
    name = "BCR_DMA_Code";
  }

  return { [name]: getFilter(name) };
};

const commonPermissionFilters = dashboardType => {
  return {
    ...TV_Viewership_Behavior(dashboardType),
    ...Demographics(dashboardType),
    ...Campaign_Date(dashboardType),
    ...DMA_Code(dashboardType)
  };
};

const CommonPermissions = ({
  filters,
  setIsAddNewPermissionModalOpen,
  onFilterNew,
  dashboardType
}) => {
  const [commonPermissions, setCommonPermissions] = useState({
    ...commonPermissionFilters(dashboardType)
  });

  const selectedCommonFilter = (e, key) => {
    const { checked } = e.target;
    commonPermissions[key].checked = checked;
    setCommonPermissions({ ...commonPermissions });
  };

  const onAddCommonFilters = () => {
    const body = Object.values(commonPermissions)
      .filter(c => c.checked)
      .map(c => {
        delete c.checked;
        delete c.disabled;

        return c;
      });

    onFilterNew(body);
  };

  const selectedFiltersCount = Object.values(commonPermissions).filter(
    c => c.checked
  ).length;

  const isButtonDisabled = !Object.values(commonPermissions).filter(
    c => c.checked
  ).length;

  const checkIfExists = c => !!filters.filter(f => f.name === c.name).length;

  return (
    <Box>
      <Box>
        <IconSvgButton
          variant="primaryBordered"
          name="add-o"
          onClick={e => setIsAddNewPermissionModalOpen(true)}
        >
          New Permission
        </IconSvgButton>
      </Box>
      <Divider />
      <Box>
        {Object.values(commonPermissions).map(c => {
          return (
            <StyledFlex
              alignItems="center"
              disabled={checkIfExists(c)}
              key={c.name}
            >
              <Checkbox
                type="checkbox"
                checked={c.checked}
                onChange={e => selectedCommonFilter(e, c.name)}
              />
              <Box ml={2}>
                <Text>{c.name}</Text>
              </Box>
            </StyledFlex>
          );
        })}
      </Box>
      <Divider />
      <Box my={2}>
        <Button onClick={onAddCommonFilters} disabled={isButtonDisabled}>
          Add {selectedFiltersCount} Selected Filters
        </Button>
      </Box>
    </Box>
  );
};

CommonPermissions.propTypes = {
  filters: PropTypes.object,
  setIsAddNewPermissionModalOpen: PropTypes.bool,
  onFilterNew: PropTypes.func,
  dashboardType: PropTypes.string
};

export default CommonPermissions;
